import { getStepBySlug } from '../../../../utils/function';
import { FILL } from '../../../actions/app/fill/fill.actions';
import { setInit } from '../../../actions/app/init/init.actions';
import { POST_SAVE_DEVIS, SAVE_DEVIS } from '../../../actions/app/saveDevis/saveDevis.actions';
import { setError, setLoader, setStep } from '../../../actions/app/ui/ui.actions';
import { API_ERROR, API_SUCCESS, apiRequest } from '../../../actions/core/api/api.actions';
import { setNotification } from '../../../actions/core/notifications/notifications.actions';
import { formatDataForApi } from '../fill/formatDataForApi';
import {analyticsSetEvent} from "../../../actions/core/analytics/analytics.actions.js";

export const saveDevisMiddleware = (dispatch) => (next) => (action) => {
    next(action);

    const { payload } = action;
    let html; let title;

    switch (action.type) {
        case POST_SAVE_DEVIS:
            const body = formatDataForApi(payload.body);

            next([
                apiRequest({
                    body,
                    method: 'POST',
                    url: payload.data,
                    entity: SAVE_DEVIS,
                    otherData: payload.meta.otherData,
                }),
                setLoader({ state: true, entity: SAVE_DEVIS }),
            ]);

            break;

        case `${SAVE_DEVIS} ${API_SUCCESS}`:
            const { devisOrSubscribe, step } = payload.meta.otherData;

            let nextActions = [
                setInit({ init: payload.data }),
                setError({ state: false, entity: SAVE_DEVIS }),
                setLoader({ state: false, entity: SAVE_DEVIS }),
            ];

            if (payload.data.data.Tarif.FeuTricolore && payload.data.data.Tarif.FeuTricolore === 'Orange') {
                nextActions.push(
                    setNotification({
                        entity: SAVE_DEVIS,
                        html: 'Pour toute informations, notre équipe se tient à votre disposition au 02 47 51 07 07',
                        icon: 'success',
                        showConfirmButton: true,
                        confirmButtonText: 'Terminer',
                        title: 'Merci, nous avons bien recu votre demande.',
                    }),
                );
            } else if (devisOrSubscribe === 'subscribe') {
                nextActions.push(setStep({ step: step + 1 }));
            } else if (devisOrSubscribe === 'devis') {
                nextActions.push(analyticsSetEvent({event: 'emailQuoteConfirmation'}));
                nextActions.push(setStep({ step: getStepBySlug('confirmation-devis') }));
            }

            window.scroll(0, 0);
            next(nextActions);
            break;

        case `${SAVE_DEVIS} ${API_ERROR}`:

            if(typeof action.payload?.data?.response?.data?.error === 'string') {
                html = action.payload?.data?.response?.data?.error
                title = 'Attention !'
            } else {
                html = `<p style='color: #004161;'>Si c'est une erreur de saisie, vous pouvez modifier les informations declarées sur les étapes précédentes</p><small>Erreur n°SAVDEV_APERR</small>`
                title = 'Les informations que vous avez saisies ne nous permettent pas de vous proposer un tarif en ligne.'
            }

            next([
                setNotification({
                    entity: FILL,
                    html,
                    title,
                    icon: 'error',
                }),
                setError({ state: true, entity: SAVE_DEVIS }),
                setLoader({ state: false, entity: SAVE_DEVIS }),
            ]);
            break;

        default:
            return null;
    }
};
